import { createContext, useContext, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { GlobalStyles, ThemeProvider } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { AuthStore } from '../stores/auth-store';
import { ThemeStore } from '../stores/theme-store';
import createAppTheme from '../theme/main';
import Loading from './Loading';
import Login from './Login';
import Router from './Router';

const authStore = new AuthStore();
const themeStore = new ThemeStore();

export const AuthStoreContext = createContext({ authStore });
export const ThemeStoreContext = createContext({ themeStore });

//=================================================================================================
const Authorization = observer(() => {
    return authStore.loading ? <Loading /> : <Login />;
});

//=================================================================================================
function Root() {
    const { authStore } = useContext(AuthStoreContext);

    useEffect(() => {
        if (localStorage.getItem('token')) refreshUser();
    }, []);

    useEffect(() => {
        //обновлять refresh token раз в 28 минут
        const intervalId = setInterval(refreshUser, 28 * 60_000);
        return () => clearInterval(intervalId);
    }, []);

    async function refreshUser() {
        try {
            await authStore.refresh();
        } catch (e) {
            console.log('refresh user error: ', e);
        }
    }

    return (
        <ThemeStoreContext.Provider value={{ themeStore }}>
            <ThemeProvider theme={createAppTheme(themeStore.mode)}>
                <GlobalStyles
                    styles={(theme) => ({
                        'body *::-webkit-scrollbar': { width: '6px' },
                        'body *::-webkit-scrollbar-track': { background: 'transparent' },
                        'body *::-webkit-scrollbar-thumb': {
                            backgroundColor: alpha(theme.palette.text.primary, 0.2),
                            borderRadius: '3px',
                        },
                        'body *::-webkit-scrollbar-thumb:hover': {
                            backgroundColor: alpha(theme.palette.text.primary, 0.35),
                        },
                        'body *': {
                            scrollbarWidth: 'thin',
                            scrollbarColor: `${alpha(theme.palette.text.primary, 0.2)} transparent`,
                        },
                        'input[type=number]::-webkit-outer-spin-button': { WebkitAppearance: 'none', margin: 0 },
                        'input[type=number]::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 },
                        'input[type=number]': { MozAppearance: 'textfield' },
                    })}
                />
                <AuthStoreContext.Provider value={{ authStore }}>
                    {authStore.user !== null ? <Router /> : <Authorization />}
                </AuthStoreContext.Provider>
            </ThemeProvider>
        </ThemeStoreContext.Provider>
    );
}

export default observer(Root);
